import React from 'react';
import pull = require("lodash/pull");
import FontIcon from 'material-ui/FontIcon';
import FlatButton from 'material-ui/FlatButton';
import {MdCheckbox, MdTextField} from 'core/components/fields/fields';
import {createForm} from 'core/form/createForm';
import StyledSelect from 'core/components/fields/styledSelect';
import {BlockComp} from 'core/components/blockComp/blockComp';
import {MdIconButton} from "core/components/buttons/icons";
import ActiveItem from 'core/components/blockComp/activeItem';
import {Validate} from 'core/form/validate';
import Add from "material-ui/svg-icons/content/add";
import {addSeparator} from "core/common/utils/arrayUtils";
import {MdDivider} from "core/components/blockComp/blockComp";
import {observer} from "mobx-react";
import {Party, Address, ADDRESSTYPE} from "party/partyDomain";
import {ObservableMap, action, observable} from "mobx";
import MdEntity, {LovItem} from "core/metamodel/mdEntity";
import {FormProps, ClosedContentProps, lovValue, IDomainObject, FieldText} from "core/form/formUtils";
import partyService from "party/partyService";
import {GOOGLE_API_KEY} from "core/common/config/variables";
import * as Colors from "material-ui/styles/colors";
import {User, UserToken} from "core/security/securityDomain";
import StyledDatePicker from "core/components/fields/styledDatePicker";
import {formatInterval} from "core/common/utils/dateUtils";
import moment from "moment";
import securityService from "core/security/securityService";
import SvgDelete = require('react-icons/lib/md/delete');
import {blue500, red500} from "material-ui/styles/colors";
import PropTypes from "prop-types";

interface UserTokenListProps {
  userObject: User;
  entities: ObservableMap<MdEntity>;
}

@observer
export default class UserTokenList extends React.Component<UserTokenListProps, undefined> {

  static contextTypes = {
    router: PropTypes.func.isRequired,
  };

  @action addToken = () => {
    console.debug('addToken');
    const {userObject, entities} = this.props;
    let newToken = new UserToken({
      active: true,
      $new: true,
      $added: true,
      validFrom: moment().format("YYYY-MM-DD")
    }).initDefaultValues();
    userObject.tokens.push(newToken);
  };

  render() {
    const {userObject, entities} = this.props;

    const header = (
      <div style={{display: 'flex', alignItems: 'center'}}>
        <div>API Tokens</div>
        <MdIconButton onClick={this.addToken}>
          <Add />
        </MdIconButton>
      </div>
    );


    return (
      <BlockComp header={header} noPadding={true} style={{display: 'flex', flexDirection: 'column'}}>
        {
          addSeparator( userObject.tokens.map((userToken, index) => <UserTokenForm dataObject={userToken}
                                                                                 rootObject={userObject}
                                                                                 key={index}
                                                                                 entities={entities}
                                                                                 entity={entities.get('UserToken')}
                                                                                 index={index}/>), <MdDivider inset={true}/>)
        }
      </BlockComp>
    );
  }
}



@createForm({
  formName: 'UserTokenForm',
  fields: [{
    name: 'tokenId'
  }, {
    name: 'tokenName'
  }, {
    name: 'active'
  }, {
    name: 'closeDate'
  }, {
    name: 'validFrom'
  }, {
    name: 'validTo'
  }]
},() => <noscript/>)
@observer
class UserTokenForm extends React.Component<FormProps<UserToken, User>, undefined> {

  @observable
  private showMap: boolean;

  @action onDelete = (evt) => {
    evt.stopPropagation();
    console.log('onDelete %o', this.props.dataObject);
    pull(this.props.rootObject.tokens, this.props.dataObject);
    return securityService.deleteToken(this.props.dataObject.tokenId);
  };

  @action generateToken = (evt) => {
    const {dataObject, rootObject} = this.props;
    securityService.generateToken(rootObject.username, dataObject).then( ut => {
      dataObject.tokenId = ut.tokenId;
      dataObject.tokenString = ut.tokenString;
      dataObject.$new = false;
    });
  };

  render() {

    const {dataObject, rootObject, index, entities, entity, formName} = this.props;
    let fields = dataObject.getFormFields(formName);
    let {tokenName, active, validFrom, validTo} = fields;

    const openContent = (
      <div>

        <div className="row">
          <div className="fx col-xs-4">
            <MdTextField {...tokenName.props} />
          </div>
          <div className="fx col-xs-3">
            <StyledDatePicker {...validFrom.props} disabled={true} />
          </div>
          <div className="fx col-xs-3">
            <StyledDatePicker {...validTo.props}  />
          </div>
          <div className="fx col-xs-2">
            <MdCheckbox {...active.props}  style={{height: 36, alignSelf: 'flex-end', marginLeft: 10}}/>
          </div>
        </div>

      </div>
    );

    const closedContent = (
      <div>
        <div style={{display: 'flex', fontSize: 14, lineHeight: '14px', marginLeft: 15, marginBottom: 10}}>
          <FieldText label={fields.tokenId.textLabel} value={dataObject.tokenId} style={{marginTop: '10px'}}/>
          <FieldText label={fields.tokenName.textLabel} value={dataObject.tokenName} style={{marginTop: '10px'}}/>
          <span className="zz-ml-10 zz-mt-10">{formatInterval(dataObject.validFrom, dataObject.validTo)}</span>
          <span className="zz-ml-10 zz-mt-10"><SvgDelete className="zz-ml-5" style={{height: 20, width: 20, cursor: 'hand'}} onClick={this.onDelete}/></span>
        </div>
        {(dataObject.tokenString) ? (
          <div className="zz-mt-10 zz-ml-15">
            <p style={{color: red500}}>Please copy this string, for security reasons, it will not be shown again:</p>
            <p style={{color: blue500, fontFamily: 'monospace'}}>{dataObject.tokenString}</p>
          </div>
        ) : null}
      </div>
    );

    return (
      <div>

        <div className={(dataObject.$new) ? "active-item--open" : ""}>
          {(dataObject.$new) ? openContent : null}
          {(!dataObject.$new) ? closedContent : null}
          {(dataObject.$new) ? <FlatButton label="Generate!" primary onClick={this.generateToken}/> : null}
        </div>

      </div>
    );
  }
}






// WEBPACK FOOTER //
// ./src/core/security/component/userTokenList.tsx